import { ADDITIONAL_INFO_KEY, EMAIL_INFO_KEY } from "lib";

const prefix = "Odigo.";

const write = (key: string, value: any, usePrefix: boolean = true) => {
  try {
    let parsedValue = value;
    if (typeof value !== "string") {
      parsedValue = JSON.stringify(value);
    }
    usePrefix
      ? localStorage.setItem(prefix + key, parsedValue)
      : localStorage.setItem(key, parsedValue);
  } catch (err) {
    console.error(err);
  }
};

const read = (key: string, usePrefix: boolean = true, json?: boolean): any => {
  try {
    const value = usePrefix
      ? localStorage.getItem(prefix + key)
      : localStorage.getItem(key);
    if (!value) return undefined;
    return json ? JSON.parse(value) : value;
  } catch (err) {
    console.error(err);
  }
};

const clear = (key: string | string[]) => {
  try {
    if (Array.isArray(key)) {
      key.forEach((item) => {
        localStorage.removeItem(prefix + item);
      });
    } else {
      localStorage.removeItem(prefix + key);
    }
  } catch (err) {
    console.error(err);
  }
};

const clearAll = () => {
  clear([ADDITIONAL_INFO_KEY, EMAIL_INFO_KEY, "login", "email","secretKey", "publicKey", "isEmailManualChanged"]);
};

export const storage = {
  write,
  read,
  clear,
  clearAll,
};
